import { entity } from "simpler-state"

// State to track which deduction IDs are currently being triaged
export const TriageInProgressState = entity<Set<string>>(new Set<string>())

export function addTriageInProgress(deductionIds: string[]) {
  TriageInProgressState.set(current => {
    const newSet = new Set(current)
    deductionIds.forEach(id => newSet.add(id))
    return newSet
  })
}

export function removeTriageInProgress(deductionIds: string[]) {
  TriageInProgressState.set(current => {
    const newSet = new Set(current)
    deductionIds.forEach(id => newSet.delete(id))
    return newSet
  })
}

export function clearTriageInProgress() {
  TriageInProgressState.set(new Set())
}

// State to track which deduction IDs BigWiz is currently running on.
export const BigWizInProgressState = entity<Set<string>>(new Set<string>())

export function addBigWizInProgress(deductionIds: string[]) {
  BigWizInProgressState.set(current => {
    const newSet = new Set(current)
    deductionIds.forEach(id => newSet.add(id))
    return newSet
  })
}

export function removeBigWizInProgress(deductionIds: string[]) {
  BigWizInProgressState.set(current => {
    const newSet = new Set(current)
    deductionIds.forEach(id => newSet.delete(id))
    return newSet
  })
}

